import { getDisplayPhone as getDisplayPhoneShared } from "utils/phoneUtils";

export function getDisplayPhone(
  telephone: { areaCode: string; number: string },
  cellphone: { areaCode: string; number: string },
): string {
  return getDisplayPhoneShared(telephone, cellphone, "Não Informado");
}
